module.exports = __webpack_public_path__ + "media/images/client-hand-stone-293c22147c7fff6166e1114b49b8ad5e.png";